import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { map, takeUntil, tap } from 'rxjs/operators';

import { LoadingService } from '../../services/loading.service';
import { AppropriatorPod, AppropriatorsService } from '../../services/appropriators.service';
import { Pod } from '../../services/pods.service';

@Component({
  selector: 'app-account-settings',
  templateUrl: './account-settings.component.html',
  styleUrls: ['./account-settings.component.scss']
})
export class AccountSettingsComponent implements OnInit, OnDestroy {

  appropriatorPods: AppropriatorPod[];
  selectedAppropriator: AppropriatorPod;
  selectedPod: Pod;

  private unsubscribe: Subject<any> = new Subject();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private loadingService: LoadingService,
    private appropriatorsService: AppropriatorsService,
  ) { }

  ngOnInit() {
    this.appropriatorsService.getAppropriatorPods();

    this.appropriatorsService.currentAppropriatorPods
      .pipe(
        takeUntil(this.unsubscribe),
        tap(currentAppPods => {
          currentAppPods = currentAppPods || [];
          currentAppPods.forEach(appPod => appPod.pods.sort(this.sortByName));
          return currentAppPods.sort(this.sortByName);
        })
      )
      .subscribe(currentAppPods => this.appropriatorPods = currentAppPods);
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  showPod(appropriator: AppropriatorPod, pod: Pod) {
    this.selectedAppropriator = appropriator;
    this.selectedPod = pod;
  }

  sortByName = (x: any, y: any): number => {
    return x.name.localeCompare(y.name);
  }

}
